import { AbstractControl, UntypedFormControl } from '@angular/forms';
import { Component, Input } from '@angular/core';
import { KeyValue } from '@angular/common';

import { SelectField, SelectFieldDataSort } from './select-data';

@Component({
  selector: 'ife-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
})
export class SelectComponent {
  @Input() field: SelectField;
  @Input() control: UntypedFormControl;
  @Input() placement = 'bottom-right';
  @Input() disabled = false;

  public updateSelection(formControl: AbstractControl, value: string) {
    this.control.setValue(value);
    this.control.markAsDirty();
  }

  public asIsOrder() {
    return 1;
  }

  public valueAscOrder(a: KeyValue<string, string>, b: KeyValue<string, string>) {
    return a.value.localeCompare(b.value);
  }

  public valueDescOrder(a: KeyValue<string, string>, b: KeyValue<string, string>) {
    return b.value.localeCompare(a.value);
  }

  getSort(sort: SelectFieldDataSort) {
    if (sort) {
      return this[this.field.sort].bind(this);
    }

    return this.asIsOrder.bind(this);
  }
}
